import { Token } from '@uniswap/sdk-core'
import { WHYDRA_ADDRESSES } from '../constants'

export interface SerializedToken {
  chainId: number
  address: string
  decimals: number
  symbol?: string
  name?: string
}

export function serializeToken(token: Token): SerializedToken {
  return {
    chainId: token.chainId,
    address: token.address,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name,
  }
}

export function formatTokenSymbol(address: string, symbol: string) {
  if (WHYDRA_ADDRESSES.includes(address)) {
    return 'WHYDRA'
  }
  return symbol
}

export function formatTokenName(address: string, name: string) {
  if (WHYDRA_ADDRESSES.includes(address)) {
    return 'Wrapped Hydra'
  }
  return name
}
